<template>
  <v-app-bar>
    <v-btn icon variant="text" aria-label="Abrir o cerrar menú" @click.stop="changeDrawerSize" v-show="isAuthenticated">
      <v-icon v-if="$vuetify.display.smAndDown">menu</v-icon>
      <v-icon v-else-if="isDrawerMini">chevron_right</v-icon>
      <v-icon v-else>chevron_left</v-icon>
    </v-btn>
    <v-app-bar-title>
      <router-link to="/" class="toolbar-link">
        <slot name="companyName"></slot>
      </router-link>
    </v-app-bar-title>
    <v-tooltip location="bottom">
      <template #activator="{ props }">
        <v-btn
          v-bind="props"
          icon
          variant="text"
          :aria-label="themeButtonLabel"
          @click="toggleTheme">
          <v-icon>{{ isDarkTheme ? 'light_mode' : 'dark_mode' }}</v-icon>
        </v-btn>
      </template>
      <span>{{ themeButtonLabel }}</span>
    </v-tooltip>
    <div class="d-none d-md-flex align-center">
      <v-btn variant="text" v-if="isAuthenticated" :loading="loggingOut" @click="logout">Cerrar sesión</v-btn>
      <v-btn variant="text" v-else to="/login">Ingresar</v-btn>
    </div>
    <v-btn v-if="isAuthenticated" class="d-md-none" icon="logout" aria-label="Cerrar sesión" :loading="loggingOut" @click="logout" />
  </v-app-bar>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import { useTheme } from 'vuetify'

export default {
  name: 'Header',
  data: () => ({ loggingOut: false }),
  setup () {
    const theme = useTheme()
    return { theme }
  },
  computed: {
    ...mapGetters(['isDrawerMini']),
    ...mapGetters('authModule', ['isAuthenticated']),
    isDarkTheme () {
      return this.theme.global.name.value === 'dark'
    },
    themeButtonLabel () {
      return this.isDarkTheme ? 'Cambiar a modo claro' : 'Cambiar a modo oscuro'
    }
  },
  methods: {
    ...mapActions(['changeDrawerSize']),
    async logout () {
      if (this.loggingOut) return
      this.loggingOut = true
      try {
        await this.$store.dispatch('authModule/logout')
        await this.$router.replace('/login')
      } finally {
        this.loggingOut = false
      }
    },
    toggleTheme () {
      const nextTheme = this.isDarkTheme ? 'light' : 'dark'
      this.theme.global.name.value = nextTheme
      localStorage.setItem('theme', nextTheme)
    }
  }
}
</script>
<style scoped>
.toolbar-link {
  color: inherit;
  text-decoration: none;
}
@media (max-width: 600px) {
  .toolbar-link { display: block; white-space: normal; font-size: 14px; line-height: 1.2; }
}
</style>
